/**
 * Horizontal placement for a dropdown hanging off a trigger: start at the trigger's left edge,
 * shift left only as far as needed to keep the right edge on screen, and never past the left
 * margin (if the panel can't fit, its start stays visible). Returns the offset from the trigger's
 * left edge in px. Pure (node --test).
 */
export function popoverOffset(
  trigger: { left: number; width: number },
  panelWidth: number,
  viewportWidth: number,
  margin = 8,
): number {
  let left = trigger.left;
  const overflowRight = left + panelWidth - (viewportWidth - margin);
  if (overflowRight > 0) left -= overflowRight;
  if (left < margin) left = margin;
  return left - trigger.left;
}
